

export default {
  wujiDashboardUser: 'https://report.bugly.tds.qq.com/page/dashboard',
  wujiDashboardProject: 'https://report.bugly.tds.qq.com/page/dashboard',
};
